import Axios from "../plugins/Axios";

const getAppInfo = async () => {
  try {
    const { data } = await Axios.get("/version");
    return {
      success: true,
      data: data.data,
    };
  } catch (error: any) {
    return {
      ...error,
      success: false,
      data: null,
    };
  }
}

export { getAppInfo as GetAppInfo };